// The signed-in session as the browser sees it: the JWT in the jwtToken cookie.

/** Whether the token can still be used: its payload decodes and its `exp` is in the future. */
export function checkJwtTokenValidity(jwtToken, now = new Date()) {
  try {
    const base64Url = jwtToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    const payload = JSON.parse(jsonPayload);
    return new Date(payload?.exp * 1000) > now;
  } catch (error) {
    return false;
  }
}
